import styled from 'styled-components';
import { IThemeProvider } from '../../../../../../../styles/theme';

export const Wrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding-top: 40px;
`;

export const Table = styled.table`
  width: 100%;
`;

export const HeaderRow = styled.tr`
  padding: 0 25px;
  display: grid;
  grid-template-columns: 5fr 1fr 1fr 8fr 1fr;
  margin-bottom: 10px;
`;

export const HeaderCell = styled.tr<IThemeProvider>`
  font-size: 14px;
  line-height: 16px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  display: flex;
  &:first-child {
    margin-left: 2.5rem;
  }
  &:nth-child(2) {
    margin-left: 0.5rem;
  }

  &:nth-child(4) {
    display: flex;
    justify-content: space-between;
    margin-left: 2.5rem;
    @media (max-width: 1360px) {
      margin-left: 3.5rem;
    }
  }
  &:nth-child(5) {
    display: flex;
    align-items: center;
    justify-content: end;
  }
`;
